<template>
    <div
        v-loading="mapLoading"
        element-loading-text="地图初始化"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#f8f8f8"
        :class="['j-map-layout', currentMeasureType]"
    >
        <div class="j-map" :id="mapRandomId" v-bind="$attrs"/>
        <j-map-coord v-if="showCoordinate" :point="coordinateTarget" />
        <slot name="control" />
        <slot />
    </div>
</template>

<script>
import baseMixins from '../mixins/baseMixins' // 基础地图载入配置[必须]
import layerMixins from '../mixins/layerMixins' // 拓展图层 网格行政区划等[可移除]
import drawMixins from '../mixins/drawMixins' // 绘画功能资源标注[可移除]
import toolMixins from '../mixins/toolMixins' // 工具函数[必须]
import measureMixins from '../mixins/measureMixins' // 测量模块[可移除]
import apiMixins from '../mixins/apiMixins' // 可直接调用的对外方法[必须][可覆盖]
export default {
  name: 'JMap',
  mixins: [baseMixins, layerMixins, drawMixins, measureMixins, toolMixins, apiMixins]
}
</script>

<style>
    .j-map-layout {
        background-color: #f8f8f8;
        position: relative;
        height: 100%;
        width: 100%;
    }
    .j-map-layout.coordinate{
        cursor: cell;
    }
    .j-map-layout .j-map{
        height: 100%;
        width: 100%;
    }
    .j-map-layout .j-map .esri-zoom{
        display: none;
    }
    .esri-view .esri-view-surface--inset-outline:focus::after {
        display: none;
    }
</style>
